// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './store'

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL
Vue.use(VueAxios, axios)

// Client
const envAppClientData = process.env.VUE_APP_CLIENT
const CLIENT =
  typeof envAppClientData === 'undefined' || envAppClientData === 'default'
    ? 'CUIABA'
    : envAppClientData
const clientData = require(`@/client/${CLIENT}/data.json`)
const APP_ENVIROMENT =
  process.env.VUE_APP_ENVIROMENT === undefined
    ? 'prod'
    : process.env.VUE_APP_ENVIROMENT
const adminUrl =
  process.env.VUE_APP_ADMIN_URL === undefined
    ? ''
    : process.env.VUE_APP_ADMIN_URL
export default { CLIENT, clientData, APP_ENVIROMENT, adminUrl }

// Configurando fonts para DOE-AL
if (CLIENT === 'DOE-AL') {
  require('@/assets/scss/doeal.scss')
}

// importando scss para o build
import '@/assets/scss/estilos.scss'

// vue awesome - font awesome
// import 'vue-awesome/icons' // importacao geral dos icones, compilacao pesa mais assim
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/sign-in-alt'
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/file-pdf'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

Vue.use(BootstrapVue)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App,
    Icon
  }
})



// WEBPACK FOOTER //
// ./src/main.js